/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerLeftDownIcon64Regular = forwardRef('ArrowDCornerLeftDownIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M23 20.5a9.5 9.5 0 0 1 9.5-9.5h24a1.5 1.5 0 1 1 0 3h-24a6.5 6.5 0 0 0-6.5 6.5v31.11c.093-.07.183-.147.268-.232l14.938-14.939a1.5 1.5 0 0 1 2.121 2.122L28.39 53.499a5.5 5.5 0 0 1-7.778 0L5.672 38.561a1.5 1.5 0 1 1 2.122-2.122l14.938 14.939c.085.085.175.162.268.233V20.5Z" })));
});
